import {
    TrustCheckCountry,
    TrustCheckOutcome,
    TrustCheckProviderStatus,
    TrustCheckRun,
    TrustCheckStatus,
    TrustCheckType,
} from '@trustoo/types/api/controllers/trustCheckReport'

export const COUNTRIES: TrustCheckCountry[] = ['NL', 'BE', 'DE', 'ES']

export const CHECK_TYPES: { value: TrustCheckType; name: string; short: string }[] = [
    { value: 'iban', name: 'IBAN', short: 'IBAN' },
    { value: 'registry', name: 'KvK / registry', short: 'Registry' },
    { value: 'repeat_offender', name: 'Repeat offender (device + IP)', short: 'Repeat' },
    { value: 'category', name: 'High-risk category', short: 'Category' },
    { value: 'website', name: 'Website legal page', short: 'Website' },
]

export const OUTCOMES: { value: TrustCheckOutcome; name: string }[] = [
    { value: 'approved', name: 'Approved' },
    { value: 'approved_low_coverage', name: 'Approved (low coverage)' },
    { value: 'under_review', name: 'Under review' },
    { value: 'blacklisted', name: 'Blacklisted' },
]

export const CHECK_STATUSES: { value: TrustCheckStatus; name: string }[] = [
    { value: 'pass', name: 'Pass' },
    { value: 'report_only', name: 'Report only' },
    { value: 'under_review', name: 'Under review' },
    { value: 'blacklisted', name: 'Blacklisted' },
    { value: 'not_checkable', name: 'Not checkable' },
]

export const PROVIDER_STATUSES: { value: TrustCheckProviderStatus; name: string }[] = [
    { value: 'live', name: 'Live' },
    { value: 'paused', name: 'Paused' },
    { value: 'churned', name: 'Churned' },
    { value: 'banned', name: 'Banned' },
    { value: 'other', name: 'Other' },
]

export const outcomeLabel = (outcome: TrustCheckOutcome): string =>
    OUTCOMES.find((option) => option.value === outcome)?.name ?? outcome

export const checkStatusLabel = (status: TrustCheckStatus | undefined): string =>
    CHECK_STATUSES.find((option) => option.value === status)?.name ?? (status || '-')

export const outcomeClassName = (outcome: TrustCheckOutcome): string => {
    if (outcome === 'blacklisted') {
        return 'bg-red-100 text-red-800'
    }
    if (outcome === 'under_review') {
        return 'bg-tertiary-100 text-tertiary-800'
    }
    if (outcome === 'approved_low_coverage') {
        return 'bg-neutral-100 text-neutral-700'
    }
    return 'bg-secondary-100 text-secondary-800'
}

export const checkStatusClassName = (status: TrustCheckStatus | undefined): string => {
    if (status === 'blacklisted') {
        return 'bg-red-100 text-red-800'
    }
    if (status === 'under_review') {
        return 'bg-tertiary-100 text-tertiary-800'
    }
    if (status === 'report_only') {
        return 'bg-primary-100 text-primary-800'
    }
    if (status === 'pass') {
        return 'bg-secondary-100 text-secondary-800'
    }
    return 'bg-neutral-100 text-neutral-600'
}

export const formatRate = (rate: number | null): string => (rate === null ? '-' : `${rate}%`)

export const runLabel = (run: TrustCheckRun): string => {
    const market = run.country_code ?? 'All markets'
    const started = (run.started_at ?? run.created).slice(0, 10)
    const progress =
        run.status === 'completed'
            ? `${run.population_size} providers`
            : `${run.processed_count} / ${run.population_size}`

    return `#${run.trust_check_run_id} · ${market} · since ${run.population_since} · ${started} · ${run.status} (${progress})`
}
